import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
// import LockIcon from '@material-ui/icons/Lock';
import PeopleIcon from '@material-ui/icons/People';
import LocationCityIcon from '@material-ui/icons/LocationCity';

// eslint-disable-next-line import/prefer-default-export
export const ListItems = ({ activeNavItem, appMeta }) => (
  <div>
    {appMeta.isAdmin ? (
      <>
        <ListItem
          button
          component={Link}
          selected={activeNavItem === 'clients'}
          to="/administration/clients"
        >
          <ListItemIcon>
            <LocationCityIcon />
          </ListItemIcon>
          <ListItemText primary="Clients" />
        </ListItem>
        <ListItem
          button
          component={Link}
          selected={activeNavItem === 'users'}
          to="/administration/users"
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
      </>
    ) : (
      <>
        <ListItem
          button
          component={Link}
          selected={activeNavItem === 'users'}
          to="/administration/users"
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Users" />
        </ListItem>
      </>
    )}
  </div>
);

ListItems.propTypes = {
  activeNavItem: PropTypes.string.isRequired,
  appMeta: PropTypes.shape({
    isInternal: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }).isRequired,
};
